import Blush from './Blush';
import EyeShadow from './EyeShadow';
import Lashes from './Lashes';

export {
  Blush,
  EyeShadow,
  Lashes
}


// WEBPACK FOOTER //
// ./src/game/components/makeUp/index.js